if(!customElements.get('arte-cart-subscription'))customElements.define('arte-cart-subscription',class extends HTMLElement{
  static busy=false;
  static plans=new Map();
  connectedCallback(){
    if(this.ready)return;
    this.ready=true;this.button=this.querySelector('[data-cart-plan-switch]');
    if(this.button){this.button.hidden=false;this.button.addEventListener('click',()=>this.change())}
  }
  async change(){
    const fromDrawer=Boolean(this.closest('arte-cart-drawer'));
    const Type=this.constructor,drawer=document.querySelector('arte-cart-drawer'),page=document.querySelector('[data-cart-section]');
    if(Type.busy||drawer?.busy)return;
    const enable=this.dataset.active!=='true',plan=enable?(Type.plans.get(this.dataset.key)||Number(this.dataset.plan)):null;
    if(enable&&!Number.isSafeInteger(plan))return;
    Type.busy=true;
    const focus={variant:this.dataset.variant,signature:this.dataset.signature,active:String(enable),plan:String(plan||'')},sectionIDs=[...new Set([this.dataset.section,drawer?.dataset.section,page?.dataset.cartSection].filter(Boolean))];
    const pageEdits=page?[...page.querySelectorAll('.v2-cart-line')].map(line=>({key:line.dataset.key,value:line.querySelector('[name="updates[]"]')?.value,original:line.querySelector('[name="updates[]"]')?.defaultValue})).filter(edit=>edit.value!==edit.original):[];
    const controls=[...document.querySelectorAll('arte-cart-drawer .v3-cart-content button,arte-cart-drawer .v3-cart-content input,[data-cart-section] button,[data-cart-section] input')].map(control=>[control,control.disabled]);
    const blocker=event=>{if(event.target.closest('arte-cart-drawer .v3-cart-content a,[data-cart-section] a')){event.preventDefault();event.stopImmediatePropagation()}};
    document.addEventListener('click',blocker,true);
    drawer?.lock(true);page?.setAttribute('aria-busy','true');controls.forEach(([control])=>control.disabled=true);
    const status=(message,error=false)=>{
      drawer?.status(message,error,error?'error':'success');
      const node=document.querySelector('[data-cart-page-status]');
      if(node){node.textContent=message;node.dataset.state=error?'error':'success'}
    };
    status(this.dataset.pending);
    const render=sections=>{
      let rendered=false;
      if(page){
        const html=sections?.[page.dataset.cartSection],next=typeof html==='string'?new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-section]'):null;
        if(next){
          const before=Number(page.querySelector('arte-shipping-progress')?.dataset.percent)||0,after=next.querySelector('arte-shipping-progress');
          if(after){after.dataset.from=String(before);after.dataset.celebrate=String(before<100&&Number(after.dataset.percent)>=100)}
          page.replaceWith(next);
          for(const edit of pageEdits){
            const line=[...next.querySelectorAll('.v2-cart-line')].find(el=>el.dataset.key===edit.key)||(edit.key===this.dataset.key?[...next.querySelectorAll('arte-cart-subscription')].find(el=>el.dataset.signature===focus.signature&&el.dataset.active===focus.active&&(!enable||el.dataset.plan===focus.plan))?.closest('.v2-cart-line'):null),input=line?.querySelector('[name="updates[]"]');
            if(input)input.value=edit.value;
          }
          rendered=true;
        }
      }
      if(drawer)rendered=drawer.renderCart(sections)||rendered;
      const scope=fromDrawer?drawer:document.querySelector('[data-cart-section]');
      const target=[...(scope?.querySelectorAll('arte-cart-subscription')||[])].find(el=>el.dataset.signature===focus.signature&&el.dataset.active===focus.active&&(!enable||el.dataset.plan===focus.plan));
      target?.querySelector('[data-cart-plan-switch]')?.focus({preventScroll:true});
      if(target&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
        const line=target.closest('.v3-cart-item,.v2-cart-line'),price=line?.querySelector('.v3-cart-line-price,.v2-line-total');
        price?.animate([{opacity:.35,transform:'translateY(4px)',color:enable?'#3e8154':'#52616b'},{opacity:1,transform:'translateY(0)'}],{duration:350,easing:'cubic-bezier(.2,.7,.2,1)'});
      }
      return rendered;
    };
    try{
      const currentResponse=await fetch(this.dataset.cart+'.js',{headers:{Accept:'application/json'},cache:'no-store'});
      if(!currentResponse.ok)throw new Error('cart');
      const current=await currentResponse.json(),index=current.items.findIndex(item=>item.key===this.dataset.key);
      if(index<0)throw new Error('line');
      const quantity=current.items[index].quantity;
      const response=await fetch(this.dataset.change,{method:'POST',headers:{Accept:'application/json','Content-Type':'application/json'},body:JSON.stringify({line:index+1,quantity,selling_plan:plan,sections:sectionIDs,sections_url:location.pathname})});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||result.message||'change');
      if(!enable){
        const original=current.items[index],properties=JSON.stringify(Object.entries(original.properties||{}).sort());
        const updated=result.items.find(item=>item.variant_id===original.variant_id&&!item.selling_plan_allocation&&JSON.stringify(Object.entries(item.properties||{}).sort())===properties);
        if(updated)Type.plans.set(updated.key,Number(this.dataset.plan));
      }
      if(!render(result.sections))throw new Error('sections');
      status(this.dataset.updated);
    }catch(error){
      console.warn('[ARTE cart subscription]',error.message);
      try{
        const url=new URL(location.pathname,location.origin);url.searchParams.set('sections',sectionIDs.join(','));
        const response=await fetch(url,{headers:{Accept:'application/json'},cache:'no-store'});
        if(response.ok)render(await response.json());
      }catch{}
      status(this.dataset.error,true);
    }finally{
      drawer?.lock(false);document.querySelector('[data-cart-section]')?.removeAttribute('aria-busy');
      controls.forEach(([control,disabled])=>{if(control.isConnected)control.disabled=disabled});
      document.removeEventListener('click',blocker,true);Type.busy=false;
    }
  }
});
